export interface JobConditionOption {
  id: number;
  condition: string;
}

export function normalizeJobConditionOptions(data: unknown): JobConditionOption[] {
  if (!data || typeof data !== 'object') return [];

  return Object.values(data)
    .map((value: any): JobConditionOption => ({
      id: Number(value?.id),
      condition: typeof value?.condition === 'string' && value.condition.trim()
        ? value.condition.trim()
        : '名称未設定',
    }))
    .filter(option => Number.isInteger(option.id))
    .sort((a, b) => a.id - b.id);
}

export function formatJobCondition(option: JobConditionOption): string {
  return `${option.condition}（${option.id}）`;
}

export function canForceChangeJobCondition(
  currentCondition: number,
  selectedCondition: number | null,
  isSubmitting: boolean,
): boolean {
  return !isSubmitting
    && Number.isInteger(selectedCondition)
    && selectedCondition !== currentCondition;
}
